/**
 * @generated SignedSource<<eafc8ba734d55c6c6c1e6d1b62715151>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShipmentNotes_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAllowCustomQuote_buyer">;
  readonly " $fragmentType": "CheckoutShipmentNotes_buyer";
};
export type CheckoutShipmentNotes_buyer$key = {
  readonly " $data"?: CheckoutShipmentNotes_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShipmentNotes_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShipmentNotes_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAllowCustomQuote_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "086e149cb42559b9577321228d82a3a4";

export default node;
